/** Delay before long-wait UX and cancel/stop are offered for an in-flight turn. */
export const TURN_LONG_WAIT_MS = 15_000

/** How long to wait for the worker to confirm a SignalR stop before resetting locally. */
export const STOP_CONFIRM_TIMEOUT_MS = 15_000
